import { Component, OnInit } from '@angular/core';
import { ReportService } from './../../services/report.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-formulall',
  templateUrl: './formulall.component.html',
  styleUrls: ['./formulall.component.css'],
})
export class FormulallComponent implements OnInit {
  constructor(private formula: ReportService) {}
  formulaAll: any = [];

  showLoading: boolean = true;
  page = 1;
  limit = 1;
  count = 0;
  search;
  date_created_after;
  date_created_before;
  token = window.localStorage.getItem('token');

  ngOnInit() {
    this.showLoading = true;

    this.getFormulall();
  }

  getFormulall() {
    this.formula
      .getViewFormulaAll(this.page, this.search)
      .toPromise()
      .then((data) => {
        console.log(data);
        this.limit = Math.ceil(data['count']);
        this.count = data['count'];
        this.formulaAll = data['results'];
        this.showLoading = false;
      })
      .catch((error) => console.log(error));
  }

  pageChanged(p) {
    this.page = p.page;
    this.getFormulall();
  }

  xslFormulaAll() {
    let initYear =
      (this.date_created_after && this.date_created_after.getFullYear()) || '';

    let initMonth =
      (this.date_created_after &&
        ('0' + (this.date_created_after.getMonth() + 1))
          .toString()
          .slice(-2)) ||
      '';

    let initDay =
      (this.date_created_after &&
        ('0' + this.date_created_after.getDate()).toString().slice(-2)) ||
      '';

    let endYear =
      (this.date_created_before && this.date_created_before.getFullYear()) ||
      '';

    let endMonth =
      (this.date_created_before &&
        ('0' + (this.date_created_before.getMonth() + 1))
          .toString()
          .slice(-2)) ||
      '';

    let endDay =
      (this.date_created_before &&
        ('0' + (this.date_created_before.getDate() + 1))
          .toString()
          .slice(-2)) ||
      '';

    let init =
      (this.date_created_after && initYear + '-' + initMonth + '-' + initDay) ||
      '';

    let end =
      (this.date_created_before && endYear + '-' + endMonth + '-' + endDay) ||
      '';
    window.open(
      environment.viewFormula +
        '?xls' +
        '&' +
        'token=' +
        this.token +
        '&start=' +
        init +
        '&end=' +
        end +
        '&search=' +
        this.search
    );
  }
}
